import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { MenuComponent } from './menu/menu.component';
import { MenuResponsiveComponent } from './menuResponsive/menu-responsive.component';
import { FooterComponent } from './footer/footer.component';

import { ExistenciasPopoverComponent } from './existenciasPopover/existencias-popover.component';
import { CarritoTamanoPopoverComponent } from './carritoTamanoPopover/carrito-tamano-popover.component';
import { ProductoMensajePopoverComponent } from './productoMensajePopover/producto-mensaje-popover.component';
import { PedidosPopoverComponent } from './pedidoPopover/pedidos-popover.component';
import { CancelarPopoverComponent } from './cancelarPopover/cancelar-popover.component';
import { MenuMantenimientoComponent } from './menu-mantenimiento/menu-mantenimiento.component';
import { PoliticaCalidadComponent } from './politicaCalidad/politica-calidad.component';
import { AvisoPrivacidadComponent } from './avisoPrivacidad/aviso-privacidad.component';
import { TerminoCondicionComponent } from './terminosCondiciones/terminos-condiciones.component';

@NgModule({
    declarations: [
        MenuComponent,
        MenuResponsiveComponent,
        FooterComponent,
        ExistenciasPopoverComponent,
        CarritoTamanoPopoverComponent,
        ProductoMensajePopoverComponent,
        PedidosPopoverComponent,
        CancelarPopoverComponent,
        MenuMantenimientoComponent,
        PoliticaCalidadComponent,
        AvisoPrivacidadComponent,
        TerminoCondicionComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        IonicModule,
    ],
    exports: [
        MenuComponent,
        MenuResponsiveComponent,
        FooterComponent,
        ExistenciasPopoverComponent,
        CarritoTamanoPopoverComponent,
        ProductoMensajePopoverComponent,
        PedidosPopoverComponent,
        CancelarPopoverComponent,
        MenuMantenimientoComponent
    ]
})
export class ComponentsModule{}
